<script setup lang="ts">
import { computed } from 'vue';
import HomepageBtn from './HomepageBtn.vue';
import { useTranslations } from '~/composables/translations';

const { $i18n } = useTranslations('components/homepage/download_solidworks');
const { $i18n: $i18nCommon } = useTranslations('common');

const features = computed((): string[] => [
  $i18n('feature1'),
  $i18n('feature2'),
  $i18n('feature3'),
  $i18n('feature4'),
]);
</script>
<template>
  <div class="download-solidworks-container px-30px px-10px--sm">
    <div
      class="homepage-max-content-container relative flex flex-column--sm align-items-center justify-space-between grid-gap-20px py-70px py-40px--sm"
    >
      <div class="flex-order-5--sm flex flex-column grid-gap-20px">
        <div class="title">
          {{ $i18n('title') }}
        </div>
        <ul class="text-content">
          <li v-for="feature in features" :key="`${feature}-list`">
            {{ feature }}
          </li>
        </ul>
        <div class="text-center--sm">
          <HomepageBtn href="https://www.solidworks.com/support/free-downloads" target="_blank">
            {{ $i18nCommon('download') }}
          </HomepageBtn>
        </div>
      </div>
      <img
        class="laptop-image"
        loading="lazy"
        src="/assets/images/homepage/sw-addin_visual-laptop.png"
      />
      <img
        class="solidworks-logo"
        loading="lazy"
        src="/assets/images/homepage/sw-addin_logo_solidworks.png"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.download-solidworks-container {
  background-color: white;
  background-repeat: repeat-x;
  border-top: solid 2px #eb0400;

  background-position-x: right;
  background-position-y: bottom;
  background-repeat: no-repeat;
  background-image: url('/assets/images/homepage/sw-banner-addin_BG.jpg');

  @include variables.for-sm {
    background-image: unset;
  }
}

.download-solidworks-container button {
  max-width: 200px;

  @include variables.for-sm {
    margin: auto;
  }
}

.laptop-image {
  height: auto;
  max-width: 450px;
  min-width: 350px;

  @include variables.for-sm {
    height: auto;
    max-width: 250px;
  }
}

.solidworks-logo {
  position: absolute;
  top: 10px;
  width: 110px;
  height: auto;
  left: 30px;

  @include variables.for-sm {
    margin: auto;
    left: unset;
  }
}

ul li {
  font-size: 18px;

  @include variables.for-sm {
    font-size: 16px;
  }
}

@include variables.for-sm {
  .title {
    text-align: center;
  }
}
</style>
